import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../ChargebackProtection.module.css';
import { CheckSmall } from '../../icons';

const dashboardUrl = process.env.REACT_APP_DASHBOARD_URL;

const Header = () => (
  <header className={styles.hero}>
    <div className={`${styles.container} ${styles.heroGrid}`}>
      <div>
        <div className={`${styles.breadcrumb} ${styles.reveal} ${styles.d1}`}>
          <Link to="/">Fyntiq Business</Link>
          <span className={styles.breadcrumbSep}>/</span>
          <Link to="/#features">Features</Link>
          <span className={styles.breadcrumbSep}>/</span>
          <span className={styles.breadcrumbCur}>Chargeback Protection</span>
        </div>
        <h1 className={`${styles.reveal} ${styles.d2}`}>
          Stay paid.<br /><span className={styles.hl}>Even against fraud.</span>
        </h1>
        <p className={`${styles.heroSub} ${styles.reveal} ${styles.d3}`}>
          Friendly fraud and unauthorized-charge disputes quietly drain honest businesses. Fyntiq screens every transaction, covers eligible fraudulent disputes, and handles the response for you.
        </p>
        <div className={`${styles.heroCta} ${styles.reveal} ${styles.d4}`}>
          <Link to={`${dashboardUrl}/signup`} className={styles.btnYellow}>Get started free</Link>
          <a href="#how" className={styles.btnOutlineHero}>See how it works</a>
        </div>
        <div className={`${styles.heroNote} ${styles.reveal} ${styles.d5}`}>
          <span><CheckSmall />Fraud screening built in</span>
          <span><CheckSmall />Disputes handled for you</span>
        </div>
      </div>

      <div className={`${styles.heroVisual} ${styles.reveal} ${styles.d3}`}>
        <div className={`${styles.floatChip} ${styles.fcCash}`}>
          <div className={`${styles.fcIc} ${styles.fcIcY}`}>
            <svg viewBox="0 0 24 24" width="18" fill="none" stroke="#161614" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 2 l8 4 v6 c0 5 -3.5 8 -8 10 c-4.5 -2 -8 -5 -8 -10 V6 z" />
            </svg>
          </div>
          <div><div className={styles.fcLab}>Dispute filed</div><div className={styles.fcVal}>Fraud</div></div>
        </div>
        <div className={`${styles.floatChip} ${styles.fcPayout}`}>
          <div className={`${styles.fcIc} ${styles.fcIcG}`}><CheckSmall /></div>
          <div><div className={styles.fcLab}>Your liability</div><div className={styles.fcVal}>$0.00</div></div>
        </div>

        <div className={styles.payCard}>
          <div className={styles.invTop}>
            <div><div className={styles.invLab}>DISPUTE</div><div className={styles.invNum}>#DSP-2208 · Northbeam</div></div>
            <span className={styles.invStatus} style={{ background: 'var(--green-soft)', color: 'var(--green)' }}>Covered</span>
          </div>
          <div className={styles.invRow}><span>Order amount</span><span className={styles.mono}>$420.00</span></div>
          <div className={styles.invRow}><span>Dispute reason</span><span className={styles.mono}>Fraudulent</span></div>
          <div className={styles.invRow}><span>Handled by</span><span className={styles.mono}>Fyntiq</span></div>
          <div className={styles.invTotal}><span>Your liability</span><span className={`${styles.mono} ${styles.monoGreen}`}>$0.00</span></div>
          <div className={styles.invPaynow} style={{ background: 'var(--green)' }}>Protected by Fyntiq ✓</div>
        </div>
      </div>
    </div>
  </header>
);

export default Header;
